import React from 'react'
import Link from 'gatsby-link'
import Tachyons from 'tachyons'

const Footer = ({ siteTitle }) => (
  <footer className="avenir pa3 pa4-l black-70 b--black-10" style={{ backgroundColor: '#00a0aa'}}>

      {/* <a href="https://www.facebook.com/" className="pv3 link dim dib mr3 black-70" title="Impossible Labs on Facebook">
        <svg className="db w2 h2" data-icon="facebook" viewBox="0 0 32 32" fill="currentColor">
          <title >facebook icon</title>
          <path d="M8 12 L13 12 L13 8 C13 2 17 1 24 2 L24 7 C20 7 19 7 19 10 L19 12 L24 12 L23 18 L19 18 L19 30 L13 30 L13 18 L8 18 z"
          ></path>
        </svg>
      </a>

      <section className="fl w-50 dib-ns w-auto-ns mr4-m mr5-l mb4 pr2 pr0-ns">
      <h4 className="f5 f4-l fw6">General Information</h4>
      <Link className="fw6 link dim black db" to="/membership/" title="Membership">Membership</Link>
      <Link className="fw6 link dim black db" to="/workshop/" title="Workshop">Workshop</Link>
      <Link className="fw6 link dim black db" to="/riverton/" title="Riverton">Around Riverton</Link>
    </section> */}
  <div className="f6 flex flex-wrap justify-between">
    <div className="w-100 w-25-ns">
      <h4 className="ttu black">Riverton Arts Centre</h4>
      <p>149 Palmerston Streeet<br/>
      Riverton-Aparima 9822</p>
      <p><a className="link dim black fw6" href="tel:(03)2349932">(03)2349932</a><br/>
      <a className="link dim black fw6" href="mailto:info@rivertonarts.org.nz">info@rivertonarts.org.nz</a></p>
    </div>
    <div className="w-100 w-25-ns">
      <h4 className="ttu black">Information</h4>
      <Link className="fw6 link dim black db" to="/preston-law-award" title="Preston Law Award">Preston Russell Law Award</Link>
      <Link className="fw6 link dim black db" to="/preston-application" title="Preston Law Award">Preston Russell Law Award Application</Link>
      <Link className="fw6 link dim black db" to="/registration" title="Registration">Online Registration</Link>
      <Link className="fw6 link dim black db" to="/volunteer" title="Volunteer">Volunteer</Link>
      <Link className="fw6 link dim black db" to="/volunteer-application" title="Volunteer Application">Volunteer Application</Link>
      <Link className="fw6 link dim black db" to="/conditions" title="Workshop">Conditions of Entry</Link>
      <Link className="fw6 link dim black db" to="/newsletter" title="Newsletter">Newsletter</Link>
      <Link className="fw6 link dim black db" to="/riverton" title="Riverton">Riverton</Link>
      <Link className="fw6 link dim black db" to="/donate" title="Donate">Donate</Link>
    </div>
    <div className="w-100 w-50-ns">
      <h4 className="ttu black">Location Map</h4>
      <p className=""><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2753.8867568805567!2d168.01231061555362!3d-46.351791876443535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa9d2f07f70a6538f%3A0x9446ac13d32914a3!2sRiverton+Community+Arts+Centre+Charitable+Trust!5e0!3m2!1sen!2snz!4v1532996062892" width="100%" height="300" frameBorder="0" style={{border:0}} allowfullscreen></iframe></p>
    </div>
    
    <div className="w-100 f7 justify-center">
    <hr />
      <span>Copyright © Riverton Community Arts Centre 2019</span>
    </div>
  </div>
</footer>
)

export default Footer
